import React from "react";
import PropTypes from "prop-types";
import {List} from "immutable";
import {Select, Modal, Input } from "antd";

class RejectionReasonModal extends React.Component {
    static propTypes={
        title: PropTypes.string,
        visible: PropTypes.bool,
        onCancel: PropTypes.func,
        onConfirm: PropTypes.func,
        reasonCategories: PropTypes.object,
        addRemarks: PropTypes.bool
    }
    state={
        hasReasonCategories: false
    }
    remarks=null;
    reason=null;

    onChangeRemarks= event => {
        this.remarks=(event&&event.target&&event.target.value);
    }
    onChangeReason=selectedOption => {
        this.reason=selectedOption;
    }

    onConfirm=() => {
        this.props.onConfirm(this.reason,this.remarks);
    }

    onCancel=() => {
        this.props.onCancel();
    }

    resetFields=() => {
        this.remarks=null;
        this.reason=null;
    }

    reasonOptions = List([])
    createReasonCategories() {
        if(this.props.reasonCategories && this.reasonOptions.size !== this.props.reasonCategories.size) {
            this.reasonOptions=this.props.reasonCategories.map((_, k) => {
                return( <Select.Option
                    key={_}
                    value={k}
                >
                    {k}
                </Select.Option>);
            }).toList();
        }
    }

    renderReasonSelect=() => {
        if(this.reasonOptions.size) {
            return (
                <Select
                    style={{ width: "100%", marginBottom: "10px"}}
                    placeholder={"Select Reason"}
                    showSearch={true}
                    onSelect={this.onChangeReason}
                    dropdownMatchSelectWidth={false}
                >
                    {this.reasonOptions}
                </Select>);
        }
        return null;
    }


    renderRemarksBox=() => {
        if(this.props.addRemarks) {
            return (
                <Input.TextArea
                    rows={4}
                    placeholder={"Remarks"}
                    onChange={this.onChangeRemarks}
                />
            );
        }
        return null;
    }


    componentDidMount() {
        this.createReasonCategories();
    }

    componentDidUpdate(prevProps) {
        if(this.props.visible!==prevProps.visible) {
            this.resetFields();
        }
    }

    render() {
        return (
            <Modal
                title={this.props.title}
                visible={this.props.visible}
                onOk={this.onConfirm}
                onCancel={this.onCancel}
            >
                {this.renderReasonSelect()}
                {this.renderRemarksBox()}
            </Modal>
        );
    }
}

export default RejectionReasonModal;